import billingService from '../services/billing.service';

const billings = {
    namespaced: true,
    state: {},
    actions: {
        //CREATE
        create(_, model) {
            return billingService.create(model);
        },
        setConvertToAccount(_, id) {
            return billingService.setConvertToAccount(id);
        },
        //READ
        get(_, params) {
            return billingService.get(params.id, params.urlParameters, params.requestId);
        },

        //UPDATE
        update(_, model) {
            return billingService.update(model);
        },

        //DELETE
        delete(_, id) {
            return billingService.delete(id);
        },
    },
    getters: {},
    mutations: {},
};

export default billings;
